module.exports = __webpack_public_path__ + "img/2.76a30eb0.jpg";